<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <div class="card-body px-lg-5 py-lg-5">
          <h1>Log in</h1>
          <br />
          <form role="form">
            <!-- <base-input
              class="input-group-alternative mb-3"
              placeholder="Account Name"
              addon-left-icon="ni ni-building"
              v-model="formData.accountname"
            >
            </base-input> -->

            <div class="row">
              <div class="col">
                <base-input
                  class="input-group-alternative mb-3"
                  placeholder="Account Name"
                  addon-left-icon="ni ni-building"
                  v-model="formData.accountname"
                >
                </base-input>
                <div v-if="$v.formData.accountname.$dirty" class="text-danger">
                  <div class="error" v-if="!$v.formData.accountname.required">
                    Field is required
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <base-input
                  class="input-group-alternative mb-3"
                  placeholder="Username/Email"
                  addon-left-icon="ni ni-email-83"
                  v-model="formData.username"
                >
                </base-input>
                <div v-if="$v.formData.username.$dirty" class="text-danger">
                  <div class="error" v-if="!$v.formData.username.required">
                    Field is required
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <base-input
                  class="input-group-alternative mb-3"
                  placeholder="Password"
                  type="password"
                  addon-left-icon="ni ni-lock-circle-open"
                  v-model="formData.password"
                >
                </base-input>
                <div v-if="$v.formData.password.$dirty" class="text-danger">
                  <div class="error" v-if="!$v.formData.password.required">
                    Field is required
                  </div>
                </div>
              </div>
            </div>

            <div class="text-center">
              <base-button
                type="primary"
                class="my-4"
                nativeType="submit"
                :disabled="formSubmitting"
                @click.prevent="loginViaBxi"
              >
                <a-spin v-if="formSubmitting" :spinning="formSubmitting" />
                <div v-else>Login via BXI</div>
              </base-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import secureStorage from '../controllers/secureStorage';
import { required } from 'vuelidate/lib/validators';
import axios from 'axios';

export default {
  name: 'Login',
  data() {
    return {
      formData: {
        username: '',
        password: '',
        accountname: ''
      },
      formSubmitting: false
    };
  },

  validations: {
    formData: {
      username: { required },
      password: { required },
      accountname: { required }
    }
  },
  created() {
    // secureStorage.clear();
    // console.log('Clear Storage');
  },
  methods: {
    async loginViaBxi() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;

        try {
          const response = await axios({
            method: 'POST',
            url: '/api/auth/login/bxi',
            data: { user: this.formData }
          });
          if (response.data.access_token) {
            this.$notification.success({
              message: 'Success'
            });

            secureStorage.clear();
            console.log('Clear Storage');

            secureStorage.setItem(
              'bxiClpAccessToken',
              response.data.access_token
            );

            secureStorage.setItem('uploadToken', response.data.upload_token);
            secureStorage.setItem('promotionToken', response.data.access_token);

            secureStorage.setItem('source', response.data.source);

            setTimeout(() => {
              this.$router.push({ name: 'Dashboard' });
            }, 1000);
          }
        } catch (e) {
          let { message } = e.response.data;
          const { username, accountname } = this.formData;

          let attemptCounter = localStorage.getItem(
            `${accountname}|${username}`
          );
          if (attemptCounter == null) {
            localStorage.setItem(`${accountname}|${username}`, 0);
          } else {
            attemptCounter = parseInt(attemptCounter) + 1;
            localStorage.setItem(`${accountname}|${username}`, attemptCounter);
          }
          if (attemptCounter > 2) {
            message =
              'Login Attemp Failed. Please contact your BXI administrator.';
          }

          this.$notification.error({
            message:
              message != undefined
                ? message
                : 'Something went wrong. Please try again.'
          });
        }

        this.formSubmitting = false;
      }
    }
  }
};
</script>
